import React, { FunctionComponent } from 'react';

export const RideIcon: FunctionComponent = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0"
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="2"
        y="5"
        width="21"
        height="14"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 5H22.5882V18.2966H2V5Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.5135 16.9883C16.9908 16.9883 15.7684 15.7444 15.7684 14.2432C15.7684 13.1923 16.3474 12.2916 17.2053 11.8198L17.9988 14.5434C18.0846 14.8222 18.3419 15.0153 18.6207 15.0153C18.685 15.0153 18.7494 15.0153 18.8137 14.9938C19.1569 14.8866 19.3499 14.522 19.2641 14.1789L18.4706 11.4981H18.5135C20.0362 11.4981 21.2586 12.742 21.2586 14.2432C21.2586 15.7444 20.0362 16.9883 18.5135 16.9883V16.9883ZM11.2862 13.2567H9.99939C9.74203 12.2487 9.14154 11.4123 8.30515 10.8547L8.96998 9.37494H14.6103L11.2862 13.2567ZM8.62684 13.2567H7.18995L7.7261 12.0771C8.13358 12.3559 8.45527 12.7849 8.62684 13.2567V13.2567ZM6.05331 16.9883C4.53064 16.9883 3.30821 15.7444 3.30821 14.2432C3.30821 12.7205 4.55208 11.4981 6.05331 11.4981C6.22488 11.4981 6.375 11.5195 6.52512 11.541L5.56005 13.6427C5.47426 13.8357 5.47426 14.0931 5.60294 14.2646C5.73162 14.4577 5.92463 14.5649 6.16054 14.5649H8.77696C8.62684 15.916 7.46875 16.9883 6.05331 16.9883V16.9883ZM18.5135 10.1684C18.3634 10.1684 18.2347 10.1684 18.0846 10.1899L16.6906 5.47175C16.6048 5.19295 16.3689 4.99994 16.0686 4.99994H14.117C13.7525 4.99994 13.4522 5.30018 13.4522 5.66477C13.4522 6.02935 13.7525 6.3296 14.117 6.3296H15.5754L16.0901 8.06673H16.0472H9.50613L9.87071 7.08021C9.9565 6.88719 9.9136 6.65129 9.80637 6.47972C9.6777 6.30815 9.48468 6.20092 9.27022 6.20092H7.06127C6.69669 6.20092 6.39645 6.50116 6.39645 6.86575C6.39645 7.23033 6.69669 7.53058 7.06127 7.53058H8.30515L7.94056 8.49565L7.10417 10.34C6.78248 10.2542 6.41789 10.2113 6.07475 10.2113C3.82292 10.1684 2 11.9914 2 14.2432C2 16.495 3.82292 18.2967 6.05331 18.2967C8.17647 18.2967 9.93505 16.6452 10.1066 14.5649H11.5864C11.7794 14.5649 11.951 14.4791 12.0797 14.329L16.4332 9.24626L16.8192 10.533C15.4252 11.1764 14.4387 12.5919 14.4387 14.2218C14.4602 16.4738 16.2831 18.2967 18.5135 18.2967C20.7439 18.2967 22.5882 16.4738 22.5882 14.2432C22.5882 12.0128 20.7653 10.1684 18.5135 10.1684V10.1684Z"
          fill="#979797"
        />
      </g>
    </svg>
  );
};
